import {
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { auth } from './firebase';

export const signInWithEmailPassword = async (email, password) => {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
};

export const sendVerificationEmail = async () => {
  if (!auth.currentUser) {
    throw new Error('No signed-in user.');
  }
  await sendEmailVerification(auth.currentUser);
};

export const sendPasswordReset = async (email) => {
  await sendPasswordResetEmail(auth, email);
};
